import React from 'react';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import AnimatedElement from './AnimatedElement';

const ImpressumSection = () => {
  return (
    <Box
      id="impressum"
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: 'primary.white',
      }}
    >
      <Container 
        maxWidth={false} 
        sx={{ 
          maxWidth: '1200px',
          px: 2,
          mx: 'auto'
        }}
      >
        <AnimatedElement>
          {/* Überschrift */}
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography
              variant="h1"
              component="h1"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 500,
                color: '#000',
                mb: 2
              }}
            >
              IMPRESSUM
            </Typography>
            <Box 
              sx={{
                height: '4px', 
                width: '100px', 
                backgroundColor: 'rgb(58, 123, 62)', 
                mx: 'auto'
              }}
            />
          </Box>
        </AnimatedElement>

        <AnimatedElement>
          {/* Hauptinhalt */}
          <Box sx={{ maxWidth: '800px', mx: 'auto' }}>
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: '1rem', md: '1.1rem' },
                lineHeight: 1.7,
                color: '#000',
                textAlign: 'left',
                '& h2': {
                  fontSize: { xs: '1.4rem', md: '1.6rem' },
                  fontWeight: 500,
                  marginTop: 4,
                  marginBottom: 2,
                  color: '#000'
                },
                '& h3': {
                  fontSize: { xs: '1.2rem', md: '1.4rem' },
                  fontWeight: 500,
                  marginTop: 3,
                  marginBottom: 1.5,
                  color: '#000'
                },
                '& p': {
                  marginBottom: 2
                },
                '& .contact-info': {
                  backgroundColor: '#f8f9fa',
                  padding: 3,
                  borderRadius: '8px',
                  marginBottom: 3,
                  borderLeft: '4px solid rgb(58, 123, 62)'
                }
              }}
            >
              <h2 style={{ textAlign: 'center' }}>‍Angaben gemäß § 5 DDG</h2>

              <p style={{ textAlign: 'center' }}>
                Corps Guestphalia Berlin <br/>
Schwendenerstrasse 13<br/>
14195 Berlin-Dahlem<br/>
              </p>
              

              <h2 style={{ textAlign: 'center' }}>Kontakt</h2>
              <p style={{ textAlign: 'center' }}>
                <strong>Telefon:</strong> 030 - 83 227 866<br />
                <strong>E-Mail:</strong> adh@guestphalia-berlin.de
              </p>



              <p style={{ marginTop: 4, fontSize: '0.9rem', color: '#666',textAlign: 'center' }}>
                Stand: 
                Dezember 2025
              </p>
            </Typography>
          </Box>
        </AnimatedElement>
      </Container>
    </Box>
  );
};

export default ImpressumSection;
